var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNavbarSettings({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.75 11.3791H24.9375V1.62906H23.3125V11.3791H22.5C22.0692 11.3795 21.6561 11.5508 21.3514 11.8555C21.0468 12.1601 20.8754 12.5732 20.875 13.0041V14.6291C20.8754 15.0599 21.0468 15.473 21.3514 15.7776C21.6561 16.0823 22.0692 16.2536 22.5 16.2541H23.3125V24.3791H24.9375V16.2541H25.75C26.1808 16.2534 26.5937 16.082 26.8983 15.7774C27.2029 15.4728 27.3744 15.0598 27.375 14.6291V13.0041C27.3746 12.5732 27.2032 12.1601 26.8986 11.8555C26.5939 11.5508 26.1808 11.3795 25.75 11.3791ZM25.75 14.6291H22.5V13.0041H25.75V14.6291Z",
    fill: "currentcolor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.625 4.87906H16.8125V1.62906H15.1875V4.87906H14.375C13.9442 4.87949 13.5311 5.05083 13.2264 5.35549C12.9218 5.66014 12.7504 6.07321 12.75 6.50406V8.12906C12.7504 8.5599 12.9218 8.97298 13.2264 9.27763C13.5311 9.58229 13.9442 9.75363 14.375 9.75406H15.1875V24.3791H16.8125V9.75406H17.625C18.0558 9.75363 18.4689 9.58229 18.7736 9.27763C19.0782 8.97298 19.2496 8.5599 19.25 8.12906V6.50406C19.2496 6.07321 19.0782 5.66014 18.7736 5.35549C18.4689 5.05083 18.0558 4.87949 17.625 4.87906ZM17.625 8.12906H14.375V6.50406H17.625V8.12906Z",
    fill: "currentcolor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 16.2541H8.6875V1.62906H7.0625V16.2541H6.25C5.81916 16.2545 5.40608 16.4258 5.10143 16.7305C4.79677 17.0351 4.62543 17.4482 4.625 17.8791V19.5041C4.62543 19.9349 4.79677 20.348 5.10143 20.6526C5.40608 20.9573 5.81916 21.1286 6.25 21.1291H7.0625V24.3791H8.6875V21.1291H9.5C9.93084 21.1286 10.3439 20.9573 10.6486 20.6526C10.9532 20.348 11.1246 19.9349 11.125 19.5041V17.8791C11.1246 17.4482 10.9532 17.0351 10.6486 16.7305C10.3439 16.4258 9.93084 16.2545 9.5 16.2541ZM9.5 19.5041H6.25V17.8791H9.5V19.5041Z",
    fill: "currentcolor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: -1,
    y: 0,
    width: 34,
    height: 34,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavbarSettings);
export default __webpack_public_path__ + "static/media/navbar-settings.3991f907.svg";
export { ForwardRef as ReactComponent };